import { render, staticRenderFns } from "./TelInput.vue?vue&type=template&id=2a67d988&scoped=true"
import script from "./TelInput.vue?vue&type=script&lang=js"
export * from "./TelInput.vue?vue&type=script&lang=js"
import style0 from "./TelInput.vue?vue&type=style&index=0&id=2a67d988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67d988",
  null
  
)

export default component.exports